var _defs, _style, _use, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "resume download-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 320,
    height: 320,
    id: "img1",
    href: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+Cjxzdmcgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cg08cmVjdCB4PSIwIiBmaWxsPSJub25lIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiLz4KDTxnPgoNPHN0eWxlPi5zdDB7ZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7fTwvc3R5bGU+Cg08cGF0aCBkPSJNMi43IDJMMiA0LjZ2MTEuOGgzLjJWMThIN2wxLjgtMS42aDIuOWw1LjctNS4yVjJIMi43ek0xNiAxMC41bC0yLjUgMi4zaC00bC0yLjIgMnYtMkg0LjJWMy4zSDE2djcuMnptLTIuNS00LjZoLTEuNHYzLjloMS40VjUuOXptLTQgMEg4LjF2My45aDEuNFY1Ljl6Ii8+Cg08L2c+Cg08L3N2Zz4="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #000000 } \r\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "twitch-svgrepo-com",
    href: "#img1",
    transform: "matrix(.994,0,0,.994,103,108)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m512 256c0 141.4-114.6 256-256 256-141.4 0-256-114.6-256-256 0-141.4 114.6-256 256-256 141.4 0 256 114.6 256 256zm-47.8 87.9c11.7-27.9 17.7-57.5 17.7-88 0-30.6-5.9-60.2-17.7-88-11.3-26.9-27.6-51-48.4-71.8-20.7-20.7-44.9-37-71.8-48.4-27.9-11.7-57.5-17.7-88-17.7-30.5 0-60.1 6-88 17.7-26.9 11.4-51 27.7-71.9 48.5-20.7 20.7-37 44.9-48.4 71.8-11.7 27.9-17.7 57.5-17.7 88 0 30.5 6 60.1 17.8 87.9 11.3 26.9 27.6 51 48.4 71.8 20.7 20.7 44.9 37 71.8 48.4 27.9 11.7 57.5 17.7 88 17.7 30.6 0 60.2-5.9 88-17.7 26.9-11.3 51-27.6 71.8-48.4 20.7-20.7 37-44.9 48.4-71.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.5f20d0147fc409466eeb45ce9f29a748.svg";
export { ForwardRef as ReactComponent };